module.exports = __webpack_public_path__ + "static/media/metodo_2.514dcf55.png";